<template>
    <div>
    <span>

      <div>
<!--        <header class="card-header grey-header d-flex mob-flex-column ai-center"><div-->
<!--                class="row flex-flow-column"><div class="col">-->
<!--          <strong>{{$t('editFlight.flightDet')}}</strong>-->
<!--        </div><p class="desc">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque, provident.</p>-->
<!--            </div></header>-->


        <div v-if="flightsList && flightsList.length" >

          <CCard v-for="(flight,index) in flightsList" :key="index+'i'" class="box-shadow-card border-none p-0">
<CCardBody>


            <cFlightLegWithPax :flightObj="flight" :flightList="flightsList"
                               @flightselected="onFlightSelection" :viewOnly="viewOnly" :journey="journeyType"
                               :isExchange="isExchange" :paxList="flight.passengerInfo"
                               @paxselected="onPaxSelection">
            </cFlightLegWithPax>
<CRow v-if='isExchange && flight.isSelected &&!viewOnly '>
    <CCol md="12" class="d-flex">
<!--        <div class="mr-10px min-w-95px w-100">-->

<!--        </div>-->
                <cTextInputComponent  v-if='isExchange && flight.isSelected &&!viewOnly '  v-model="flight.remarks" :label="$t('exchange.remarks')" class="w-100">
                </cTextInputComponent>
    </CCol>
</CRow>

       <!-- <div class="flight-details-return-exchange"  :class="isExchange?{ disable: !flight.canExchange|| viewOnly } : { disable: !flight.canRefund || viewOnly}"
            @click="isExchange? (flight.canExchange && !viewOnly?onFlightSelection(flight):null) : (flight.canRefund  && !viewOnly?onFlightSelection(flight):null)"
            v-if="
                 flight.flightInfo && flight.flightInfo.length
                ">
            <div  
                  class="w-100 justify-content-center d-flex flex-flow-column connection-flight-box-wrap">
                <div  class="d-flex justify-content-between w-100 m-auto connectingflight-title">
                    <div > Flight Details</div>
                </div>
                <div  class="connectingRow w-100">
                    <div  class="main-info-wrap flex-flow-column w-100">
                        <div  class="max-w-620px mt-10px w-100 m-auto">
                            <div  class="flight-code-name">
                                <div >
                                    <div  class="d-flex"><img
                                            :src="flight.flightInfo[0].flight.logo_url"
                                            height="30px">
                                        <div  class="ml-10px" v-if="flight.flightInfo[0].flight.airline_name">   <span >
                  {{ flight.flightInfo[0].flight.airline_name }}</span>   {{ flight.flightInfo[0].flight.FlightNo }}
                                        </div>
                                    </div>
                                </div>
                                <div >
                                    <div >{{$t('editFlight.class')}} {{flight.flightInfo[0].flight.Bookingclass}}</div>
                                </div>
                            </div>
                            <div  class="flight-details-cf">
                                <table >
                                    <tbody >
                                    <tr >
                                        <td ><img
                                                src="@imgPath/img/svg/icons/take-off-gray.svg" width="20px">
                                        </td>
                                        <td >



                                            <div >{{
                    flight.flightInfo[0].flight.DepDate
                    |formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)
                    }}</div>
                                        </td>
                                        <td > {{
                    flight.flightInfo[0].flight.DepDate
                    | formatDate
                    }}</td>
                                        <td ><span > {{ flight.flightInfo[0].flight.depCity }}</span> {{ flight.flightInfo[0].flight.DepAirport }}</td>
                                        <td  class="d-flex"><img
                                                src="@imgPath/img/svg/icons/Suitcase_icon.svg"
                                                width="20px" alt="">
                                            <div  class="ml-10px"> hard code</div>
                                        </td>
                                    </tr>
                                    <tr >
                                        <td ><img
                                                src="@imgPath/img/svg/icons/landing-gray.svg" width="20px"
                                                alt=""></td>
                                        <td >

                                            <div > {{
                    flight.flightInfo[ flight.flightInfo.length-1].flight.ArrDate
                    | formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)
                    }}</div>
                                        </td>
                                        <td >{{
                    flight.flightInfo[ flight.flightInfo.length-1].flight.ArrDate
                    | formatDate
                    }}</td>
                                        <td ><span >{{ flight.flightInfo[flight.flightInfo.length-1].flight.arrCity}}</span> {{ flight.flightInfo[flight.flightInfo.length-1].flight.ArrAirport }}</td>
                                        <td >
                                            <div  class="ml-auto">{{flight.travelDuration|convertToHrMin("minutes","H [h] mm [m]") }}</div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

   </div> -->
</CCardBody>

              <!-- <CRow :style="{ color: flight.isSelected ? 'red' : 'blue' }">
                <strong>
                  {{
                  ( journeyType==trip.MULTI_CITY)? $t("editFlight.leg")+(index+1): ( journeyType==trip.ROUND_TRIP && index==1)? $t("editFlight.retFlight") : $t("editFlight.depFlight")
                  }}
                </strong>
              </CRow> -->
              <!-- <br /> -->
<!--              table start-->
<!--            <CRow-->
<!--                :class="isExchange?{ disable: !flight.canExchange|| viewOnly } : { disable: !flight.canRefund || viewOnly}"-->
<!--                @click="isExchange? (flight.canExchange && !viewOnly?onFlightSelection(flight):null) : (flight.canRefund  && !viewOnly?onFlightSelection(flight):null)"-->
<!--                v-if="-->
<!--                 flight.flightInfo && flight.flightInfo.length-->
<!--                "-->
<!--               >-->
<!--                <CCol>-->
<!--                  <CIcon v-if="flight.isSelected" name="cil-star"></CIcon>-->
<!--                  <CIcon v-else name="cil-ban"></CIcon>-->
<!--                </CCol>-->

<!--                <CCol>-->
<!--                  <img :src="flight.flightInfo[0].flight.logo_url" width="40px" />-->
<!--                </CCol>-->
<!--                <CCol v-if="flight.flightInfo[0].flight.airline_name">-->
<!--                  <strong style="white-space: nowrap">{{ flight.flightInfo[0].flight.airline_name }}</strong>-->
<!--                  <br />-->
<!--                  <span>{{ flight.flightInfo[0].flight.FlightNo }}</span>-->
<!--                </CCol>-->
<!--                <CCol>{{$t('editFlight.class')}} {{flight.flightInfo[0].flight.Bookingclass}}</CCol>-->
<!--                <CCol>-->
<!--                  <span>-->
<!--                    {{-->
<!--                    flight.flightInfo[0].flight.DepDate-->
<!--                    | formatDate-->
<!--                    }}-->
<!--                  </span>-->
<!--                  <strong>-->
<!--                    {{-->
<!--                    flight.flightInfo[0].flight.DepDate-->
<!--                    |formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)-->
<!--                    }}-->
<!--                  </strong>-->
<!--                  <br />-->
<!--                  <span>{{ flight.flightInfo[0].flight.DepAirport }}</span>-->
<!--                  <span>{{ flight.flightInfo[0].flight.depCity }}</span>-->
<!--                </CCol>-->

<!--                <CCol>{{flight.travelDuration|convertToHrMin("minutes","H [h] mm [m]") }}</CCol>-->

<!--                <div class="f_icon">-->
<!--                  <img src="~@imgPath/img/svg/icons/flight-black.svg" alt />-->
<!--                  {{ flight.flightInfo[0].connectingNumber==null? $t('editFlight.nonStop'):flight.flightInfo.length+$t('editFlight.stops') }}-->
<!--                  <br />-->

<!--                  <br />-->
<!--                </div>-->

<!--                <CCol></CCol>-->
<!--                <CCol>-->
<!--                  <span>-->
<!--                    {{-->
<!--                    flight.flightInfo[ flight.flightInfo.length-1].flight.ArrDate-->
<!--                    | formatDate-->
<!--                    }}-->
<!--                  </span>-->
<!--                  <strong>-->
<!--                    {{-->
<!--                    flight.flightInfo[ flight.flightInfo.length-1].flight.ArrDate-->
<!--                    | formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)-->
<!--                    }}-->
<!--                  </strong>-->
<!--                  <br />-->
<!--                  <span>{{ flight.flightInfo[flight.flightInfo.length-1].flight.ArrAirport }}</span>-->
<!--                  <span>{{ flight.flightInfo[flight.flightInfo.length-1].flight.arrCity}}</span>-->
<!--                </CCol>-->
<!--              </CRow>-->
<!--              table end-->

              <!-- <br /> -->
              <!-- <CRow v-if="isExchange">

                <CCol v-if='viewOnly'>
                  <label v-if="flight.exchangedDate">
                           {{$t('editFlight.exchangedDate')}}
                  </label>

                  <span>
                    <strong>


                    {{flight.exchangedDate|formatDate}}
                     </strong>
                  </span>

                </CCol>
                <CCol v-else-if="isExchange && !viewOnly">

                  <label>
                   {{$t('editFlight.exchangeDate')}}
                  </label>
                   <strong class="disable" v-if="!flight.canExchange">
                    {{flight.exchangeDate|formatDate}}
                     </strong>
                  <HotelDatePicker v-else-if="flight.canExchange && journeyType==trip.ROUND_TRIP"
                    :closeDatepickerOnClickOutside="true"

                    :startDate="new Date()"
                    :singleDaySelection="true"
                    :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"
                    :minNights="0"
                    :i18n="assigni18nObjByLang(flight.exchangeDate)"
                    :enableCheckout="false"
                    :showYear="true"

                    :endDate='  (  flightsList[flightsList.length-1].flightInfo[ 0].flight.DepDate)'

                    :displayClearButton="false"
                    :hoveringTooltip="false"
                    @check-in-changed="(val)=>{flight.exchangeDate=val}"
                  ></HotelDatePicker>
                    <HotelDatePicker v-else-if="flight.canExchange"
                    :closeDatepickerOnClickOutside="true"

                    :startDate="new Date()"
                    :singleDaySelection="true"
                    :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"
                    :minNights="0"
                    :i18n="assigni18nObjByLang(flight.exchangeDate)"
                    :enableCheckout="false"
                    :showYear="true"



                    :displayClearButton="false"
                    :hoveringTooltip="false"
                    @check-in-changed="(val)=>{flight.exchangeDate=val}"
                  ></HotelDatePicker>
                </CCol>

                <CCol>


                <cTextInputComponent  v-if='isExchange && flight.isSelected &&!viewOnly '  v-model="flight.remarks" :label="$t('exchange.remarks')">

                    </cTextInputComponent>



                </CCol>
              </CRow> -->

              <!-- <br /> -->

              <!-- <CCard>
                <CRow v-if="flight.flightInfo && flight.flightInfo.length>1">
                  <div v-for="(connFlight,ind) in flight.flightInfo" :key="ind">
                    <CRow style="margin-left: 300px;">
                      <CCol>
                        <img :src="connFlight.flight.logo_url" width="40px" />
                      </CCol>
                      <CCol v-if="connFlight.flight.airline_name">
                        <strong style="white-space: nowrap">{{ connFlight.flight.airline_name }}</strong>
                        <br />
                        <span>{{ connFlight.flight.FlightNo }}</span>
                      </CCol>
                      <CCol
                        v-if="connFlight.Bookingclass"
                      >{{$t('editFlight.class')}} {{connFlight.Bookingclass}}</CCol>
                      <CCol>
                        <span>
                          {{
                          connFlight.flight.DepDate
                          | formatDate
                          }}
                        </span>
                        <strong>
                          {{
                          connFlight.flight.DepDate
                          | formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)
                          }}
                        </strong>
                        <br />
                        <span>{{ connFlight.flight.DepAirport }}</span>
                        <span>{{ connFlight.flight.depCity }}</span>
                      </CCol>

                      <CCol
                        style="    white-space: nowrap"
                      >{{connFlight.flight.DurationInMin|convertToHrMin("minutes","H [h] mm [m]") }}</CCol>

                      <CCol></CCol>
                      <CCol>
                        <span>
                          {{
                          flight.flightInfo[ flight.flightInfo.length-1].flight.ArrDate
                          | formatDate
                          }}
                        </span>
                        <strong>
                          {{
                          connFlight.flight.ArrDate
                          | formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)
                          }}
                        </strong>
                        <br />
                        <span>{{ connFlight.flight.ArrAirport }}</span>
                        <span>{{ connFlight.flight.arrCity}}</span>
                      </CCol>
                    </CRow>
                  </div>
                </CRow>
              </CCard> -->

              <!-- <br />
              <br /> -->
              <!-- <cEditPassn
                v-if="showPax"
                :viewOnly="viewOnly||isExchange"
                :isExchange="isExchange"
                @input="onPaxSelection"
                :key="'pax'+index"
                v-bind:lsPassn="flight.passengerInfo"
              ></cEditPassn> -->
              
          </CCard>
        </div>
      </div>
    </span>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import cFlightLegWithPax from "./../../../booking/flight/details/cFlightLegWithPax"
    import router, {navigate, goBack, updateDataEdited} from "./../../../../router/index";
    import {formatDate} from "./../../../../util/date/dateFunctions";
    import {
        VALIDATE_SUCCESS_RES,
        getErrorMessage
    } from "./../../../../util/apiValidate";
    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES
    } from "./../../../../config/API_DATA";
    import {
        COMPONENT_NAME,
        PATHNAME,
        POSTPAID_TYPE,
        ALL_CLIENT_CODE,
        DATE_TIME_FORMAT,
        TRIP,BOOKING_ORDER_TYPE,REFUND_SEGMENT_STATUS, REFUND_ORDER_DET,ORDER
    } from "./../../../../util/constants";
    import {cloneData, cloneDeep, OrderByList} from "./../../../../util/util";
    import BaseConfiguration from "./../../../../config/base.js";
    import Logger from "./../../../../services/logger";
    import cTextInputComponent from './../../../form/cTextInputComponent'
    import cEditPassn from "./cEditPassn";
    import HotelDatePicker from "vue-range-datechooser";

    export default {
        name: COMPONENT_NAME.C_EDIT_FLIGHT,

        components: {
            cFlightLegWithPax,
            cEditPassn,
            HotelDatePicker,
            cTextInputComponent
        },

        props: {
            lsFlights: {
                type: Array,
                default: null
            },

            isExchange: {
                type: Boolean,
                default: false
            },

            journeyType: {
                type: String | Number,
                default: null
            },

            showPax: {
                type: Boolean,
                default: false
            },

            viewOnly: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                flightsList: [],
                trip: TRIP
                //  DATE_TIME_FORMAT:DATE_TIME_FORMAT
            };
        },

        computed: {
            DATE_TIME_FORMAT() {
                return DATE_TIME_FORMAT;
            },
             ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES",
    }),
    ...mapGetters("sAgtLogin", {
      AGENT_SIGNIN_RES: "GET_SIGNIN_RES",
    }),
        },

        methods: {
            onPaxSelection(pPaxObj, passnList, porderItemId) {
                try {
                  
                    if (BaseConfiguration.isDebug) console.log("onPaxSelection.");
                    if (pPaxObj && pPaxObj.isSelected != null) {
                        pPaxObj.isSelected = !pPaxObj.isSelected;
                    } else {
                        pPaxObj.isSelected = true;
                    }
                    // this.passengersList = cloneDeep(this.passengersList);

                    let pPaxList = cloneDeep(passnList)
                    let paxObj = null;
                    // if (pPaxList && pPaxList.length) {
                    //   paxObj = pPaxList.find(pax => {
                    //     return pax && pax.isSelected;
                    //   });
                    // }
                    if (pPaxObj) {
                        paxObj = pPaxObj
                    }

                    if (this.flightsList && this.flightsList.length) {
                        this.flightsList.forEach(flight => {
                            // let selectedPax = flight.passengerInfo.find(pax => {
                            //     if (paxObj) return pax.ticketNumber == paxObj.ticketNumber;
                            //     else return false;
                            // });

                             let selectedPax 
                             if(flight.orderItemId == porderItemId){
                                 selectedPax = true;
                             }
                                else { 
                                    selectedPax = false;
                                }
                           

                            if (selectedPax) {
                                if (this.isExchange && flight.canExchange) {
                                    flight.isSelected = true;
                                } else if (flight.canRefund) {
                                    let isValidSel=false;
                                    pPaxList.some(function (pax) {
                                        if(pax.isSelected){
                                            isValidSel=true;
                                        }
                                        return pax.isSelected;
                                    });
                                    if(isValidSel) {
                                    flight.isSelected = true;
                                    }else{
                                      flight.isSelected = false;  
                                    }
                                }
                                flight.passengerInfo = cloneData(pPaxList);
                            } else {
                                // let checkFlight = pPaxList.some(
                                //     pax => pax.ticketNumber == flight.passengerInfo[0].ticketNumber
                                // );
                                let checkFlight; 

                                if(flight.orderItemId == porderItemId){
                                 checkFlight = true;
                                 }
                                else { 
                                    checkFlight = false;
                                }

                                if (checkFlight) {
                                    flight.isSelected = false;

                                    flight.passengerInfo = cloneData(pPaxList);
                                }
                            }
                        });
                        updateDataEdited(true);
                        this.flightsList = cloneData(this.flightsList);
                        this.$emit("input", cloneData(this.flightsList));
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_EDIT_FLIGHT,
                        "error in onPaxSelection.",
                        err.toString(),
                        "onPaxSelection.",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onFlightSelection(pFlightObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onFlightSelection");

                    if (pFlightObj && pFlightObj.isSelected != null) {
                        pFlightObj.isSelected = !pFlightObj.isSelected;
                        if(this.isExchange) {
                        if(pFlightObj.isSelected == false) {
                          this.$root.$emit("openExcDatePicker",false,pFlightObj.orderItemId);
                        } else{
                          this.$root.$emit("openExcDatePicker",true,pFlightObj.orderItemId);
                        }
                        }
                    } else {
                        pFlightObj.isSelected = true;
                        if(this.isExchange){
                        this.$root.$emit("openExcDatePicker",true,pFlightObj.orderItemId);
                        }
                    }
                    if (
                        pFlightObj &&
                        pFlightObj.passengerInfo &&
                        pFlightObj.passengerInfo.length
                    ) {
                        pFlightObj.passengerInfo.forEach(passn => {
                            if (this.isExchange && passn.canExchange) {
                                passn.isSelected = pFlightObj.isSelected;
                            } else if (passn.canRefund)
                                passn.isSelected = pFlightObj.isSelected;
                        });
                        pFlightObj.passengerInfo = cloneData(pFlightObj.passengerInfo);
                    }
                    // this.flightsList = cloneData(pFlightObj);
                    
                        updateDataEdited(true);
                    this.flightsList = cloneData(this.flightsList);

                    this.$emit("input", cloneData(this.flightsList));
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_EDIT_FLIGHT,
                        "error in onFlightSelection",
                        err.toString(),
                        "onFlightSelection",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            assigni18nObjByLang(pCurrDueDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

                    retValue = {
                        night: this.$t("flightDatePicker.night"),
                        nights: this.$t("flightDatePicker.nights"),
                        "day-names": [
                            this.$t("flightDatePicker.sun"),
                            this.$t("flightDatePicker.mon"),
                            this.$t("flightDatePicker.tue"),
                            this.$t("flightDatePicker.wed"),
                            this.$t("flightDatePicker.thur"),
                            this.$t("flightDatePicker.fri"),
                            this.$t("flightDatePicker.sat")
                        ],
                        "check-in": pCurrDueDate
                            ? formatDate(pCurrDueDate, DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT)
                            : this.$t("flightDatePicker.checkIn"),
                        "check-out": this.$t("flightDatePicker.checkOut"),
                        "month-names": [
                            this.$t("flightDatePicker.jan"),
                            this.$t("flightDatePicker.feb"),
                            this.$t("flightDatePicker.mar"),
                            this.$t("flightDatePicker.apr"),
                            this.$t("flightDatePicker.may"),
                            this.$t("flightDatePicker.jun"),
                            this.$t("flightDatePicker.july"),
                            this.$t("flightDatePicker.aug"),
                            this.$t("flightDatePicker.sep"),
                            this.$t("flightDatePicker.oct"),
                            this.$t("flightDatePicker.nov"),
                            this.$t("flightDatePicker.dec")
                        ]
                    };
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_EDIT_FLIGHT,
                        "error in assigni18nObjByLang",
                        err.toString(),
                        "assigni18nObjByLang",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            toGetFlightStatus(pLsFlights) {
                try {
                  if(BaseConfiguration.isDebug) console.log("toGetFlightStatus");
                       if(pLsFlights) {
                      // for (let i = 0; i < pLsFlights.length; i++) {
              if(pLsFlights) {
                // if(pLsFlights.orderType == 1){
                //     if(pLsFlight.segmentStatus == BOOKING_ORDER_TYPE.BOOKING_ORDER) {
                //       pLsFlights["flightStatus"] = null;
                //     }
                //   }
                  if(pLsFlights.orderType == BOOKING_ORDER_TYPE.REFUND){
                    if(pLsFlights.segmentStatus == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                      if(pLsFlights.status==REFUND_ORDER_DET.SUCCESS_FAIL){
                            pLsFlights["flightStatus"] = this.$t('bookingDetail.refundProcessing');

                      }else if(pLsFlights.status==REFUND_ORDER_DET.ONLY_PROCESS){
                      pLsFlights["flightStatus"] = this.ADMIN_SIGNIN_RES? this.$t('bookingDetail.newRefundReq'):
                       this.$t('bookingDetail.refundReq');
                      }
                    }
                    else if(pLsFlights.segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                      pLsFlights["flightStatus"] = this.$t('bookingDetail.refundSuccess');
                    }
                    else if(pLsFlights.segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                      pLsFlights["flightStatus"] = this.$t('bookingDetail.refundFail');
                    }
                  }
              }
              }
              // }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_EDIT_FLIGHT,
                          "error in toGetFlightStatus",
                          err.toString(),
                          "toGetFlightStatus",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return pLsFlights;
                }, 

            toGetStatus(pLsFlights) {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("toGetStatus");
                  if(pLsFlights) {
                      for (let i = 0; i < pLsFlights.length; i++) {
              if(pLsFlights) {
                if(pLsFlights[i].orderType == 1){
                    if(pLsFlights[i].segmentStatus == BOOKING_ORDER_TYPE.BOOKING_ORDER) {
                      pLsFlights[i]["flightStatus"] = null;
                    }
                  }
                  if(pLsFlights[i].orderType == BOOKING_ORDER_TYPE.EXCHANGE){
                    if(pLsFlights[i].segmentStatus == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                      if(pLsFlights[i].status==REFUND_ORDER_DET.SUCCESS_FAIL){
                      pLsFlights[i]["flightStatus"] = this.$t('bookingDetail.exchangeProcessing');

                      }else if(pLsFlights[i].status==REFUND_ORDER_DET.ONLY_PROCESS){
                      pLsFlights[i]["flightStatus"] = this.ADMIN_SIGNIN_RES ? this.$t('bookingDetail.newExchangeReq'):
                      this.$t('bookingDetail.exchangeReq');

                      }
                    }
                    else if(pLsFlights[i].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                      pLsFlights[i]["flightStatus"] = this.$t('bookingDetail.exchangeSuccess');
                    }
                    else if(pLsFlights[i].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                      pLsFlights[i]["flightStatus"] = this.$t('bookingDetail.exchangeFail');
                    }
                  }
              }
              if(pLsFlights[i].passengerInfo){
                for (let j = 0; j < pLsFlights[i].passengerInfo.length; j++) {
                  if(pLsFlights[i].orderType == BOOKING_ORDER_TYPE.BOOKING_ORDER){
                    if(pLsFlights[i].passengerInfo[j].segmentStatus == 1) {
                      pLsFlights[i].passengerInfo[j]["paxStatus"] = null;
                    }
                  }
                  // if(pLsFlights[i].orderType ==BOOKING_ORDER_TYPE.EXCHANGE){
                  //   if(pLsFlights[i].passengerInfo[j].segmentStatus == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                  //     if(pLsFlights[i].status==REFUND_ORDER_DET.SUCCESS_FAIL){
                  //           pLsFlights[i].passengerInfo[j]["paxStatus"] = this.$t('bookingDetail.exchangeProcessing');

                  //     }else if(pLsFlights[i].status==REFUND_ORDER_DET.ONLY_PROCESS){
                  //     pLsFlights[i].passengerInfo[j]["paxStatus"] = this.$t('bookingDetail.exchangeReq');
                  //     }
                  //   }
                  //   else if(pLsFlights[i].passengerInfo[j].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                  //     pLsFlights[i].passengerInfo[j]["paxStatus"] = this.$t('bookingDetail.exchangeSuccess');
                  //   }
                  //   else if(pLsFlights[i].passengerInfo[j].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                  //     pLsFlights[i].passengerInfo[j]["paxStatus"] = this.$t('bookingDetail.exchangeFail');
                  //   }
                  // }
                  if(pLsFlights[i].orderType == BOOKING_ORDER_TYPE.REFUND){
                    if(pLsFlights[i].passengerInfo[j].segmentStatus == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                      if(pLsFlights[i].status==REFUND_ORDER_DET.SUCCESS_FAIL){
                     pLsFlights[i].passengerInfo[j]["paxStatus"] = this.$t('bookingDetail.refundProcessing');

                      }else if(pLsFlights[i].status==REFUND_ORDER_DET.ONLY_PROCESS){
                      pLsFlights[i].passengerInfo[j]["paxStatus"] =  this.ADMIN_SIGNIN_RES ? this.$t('bookingDetail.newRefundReq'):
                      this.$t('bookingDetail.refundReq');
                      }
                    }
                    else if(pLsFlights[i].passengerInfo[j].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                      pLsFlights[i].passengerInfo[j]["paxStatus"] = this.$t('bookingDetail.refundSuccess');
                    }
                    else if(pLsFlights[i].passengerInfo[j].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                      pLsFlights[i].passengerInfo[j]["paxStatus"] = this.$t('bookingDetail.refundFail');
                    }
                  }
                }

              }
              
            }
            let isFlightStatus = true;
            loop1:for (let k = 0; k < pLsFlights.length; k++) {
              loop2:for (let l = 0; l < pLsFlights[k].passengerInfo.length-1; l++) {
                if(pLsFlights[k].passengerInfo[l].paxStatus == pLsFlights[k].passengerInfo[l+1].paxStatus){
                  isFlightStatus = true;
                } else{
                  isFlightStatus = false;
                  break loop2;
                }
              }
              if(isFlightStatus==true) {
               pLsFlights[k] = this.toGetFlightStatus(pLsFlights[k]);
              }
            }
                  }
            retValue = pLsFlights;
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_EDIT_FLIGHT,
                          "error in toGetStatus",
                          err.toString(),
                          "toGetStatus",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
            }, 
        sortPassengerInfo(passengerInfo) {
          return OrderByList(passengerInfo,"paxType",ORDER.ASC);
        },
        },


        

        created() {
            try {
                if (BaseConfiguration.isDebug) console.log("created");

                if (this.lsFlights && this.lsFlights.length) {
                    this.lsFlights = this.toGetStatus(this.lsFlights);
                    this.flightsList = cloneDeep(this.lsFlights);
                    for(let flightList of this.flightsList)
                    {
                      flightList.passengerInfo = this.sortPassengerInfo(flightList.passengerInfo);
                    }
                }
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.C_EDIT_FLIGHT,
                    "error in created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        }
    };
</script>


<style>
    .disable {
        background-color: #ced2d8;
    }
</style>
